import adminApi from '../api/adminApi'
import { request } from './ajaxProxy.js'
var validate = {

	/**
	 * 手机号验证
	 */
	validPhone:function(rule, value, callback){
	    const reg = /^1[3|4|5|6|7|8|9][0-9]\d{8}$/
		if (!value) {
			callback(new Error('请输入电话号码'))
		} else if (!reg.test(value)) {

			callback(new Error('请输入正确的11位手机号码'))
		} else {
			callback()
		}
	},
	/**
	 * 邮箱验证
	 */
	validEmail:function(rule, value, callback){
		const reg = /^([a-zA-Z0-9_\.\-])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/
		if (!value) {
			callback(new Error('请输入邮箱'))
		} else if (!reg.test(value)) {
			callback(new Error('请输入正确的邮箱地址'))
		} else {
			callback()
		}
	},

	/**
	 * 数字和小数点验证（小于一亿）
	 */
	validNumber:function(rule, value, callback){
	    const reg = /^\d*\.?\d*$/
		 if (value && !reg.test(value)) {
			callback(new Error('仅支持数字和小数点'))
		} else {
			if(value*1 > 99999999.99){
				callback(new Error('请输入小于一亿的数字'))
			} else {
				callback()
			}
		}
	},

	/**
	 * 只数字验证
	 */
	validOnlyNumber:function(rule, value, callback){
	    const reg =/^[0-9]+$/
		 if (value && !reg.test(value)) {
			callback(new Error('仅支持数字'))
		} else {
			callback()
		}
	},
	

  /**
   * 数字验证
   */
  validFigure:function(rule, value, callback){
    const reg = /^\d*$/
    if (value && !reg.test(value)) {
      callback(new Error('仅支持数字'))
    } else {
      callback()
    }
  },
  /**
   * 统一信用代码验证
   */
  validPermitCode:function(rule, value, callback){
    const reg = /[^_IOZSVa-z\W]{2}\d{6}[^_IOZSVa-z\W]{10}/g
    if (value && !reg.test(value)) {
      callback(new Error('请输入正确的统一信用代码'))
    } else {
      callback()
    }
  },

  /**
   * 手机号验证(为空不验证)
   */
  validPhoneNumber:function(rule, value, callback){
    const reg = /^1[3|4|5|6|7|8|9][0-9]\d{8}$/
    if (value && !reg.test(value)) {
      callback(new Error('请输入正确的11位手机号码'))
    } else {
      callback()
    }
  },

  /**
   * 邮箱验证(为空不验证)
   */
  validEmails:function(rule, value, callback){
    const reg = /^([a-zA-Z0-9_\.\-])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/
    if (value && !reg.test(value)) {
      callback(new Error('请输入正确的邮箱地址'))
    } else {
      callback()
    }
  },
  
  /**
   * 只能输入字母和数字
   */
  validLetterAndNum:function(rule, value, callback){
    const reg = /^[0-9a-zA-Z]+$/
    if (value && !reg.test(value)) {
      callback(new Error('仅支持字母和数字'))
    } else {
      callback()
    }
  },


	

}
export default validate



// WEBPACK FOOTER //
// ./src/utils/validate.js